"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Travel2 = function Travel2(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 40 40",
    width: "40",
    height: "40"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.393,17.891c1.904-1.598,2.152-4.436,0.554-6.34C8.092,10.532,6.83,9.944,5.5,9.944H2.584c-0.138,0-0.25-0.112-0.25-0.25 c0-0.022,0.003-0.044,0.009-0.065c1.407-5.33,6.868-8.511,12.198-7.105c0.82,0.216,1.609,0.536,2.348,0.952 c0.12,0.068,0.163,0.22,0.096,0.34c-0.044,0.079-0.127,0.127-0.218,0.128H14.25c-1.519,0-2.75,1.231-2.75,2.75 s1.231,2.75,2.75,2.75c0.691,0.005,1.351,0.289,1.83,0.788c0.05,0.045,0.108,0.079,0.171,0.1L18.5,10.31 c1.841,0.003,3.443,1.259,3.884,3.046c0.02,0.084,0.083,0.151,0.165,0.178c0.337,0.111,0.659,0.265,0.957,0.458 c0.117,0.074,0.272,0.04,0.346-0.078c0.019-0.03,0.032-0.064,0.037-0.099C23.963,13.278,24,12.736,24,12.194 c0.004-6.627-5.365-12.003-11.992-12.008C5.38,0.182,0.004,5.551,0,12.179C-0.003,17.631,3.669,22.4,8.941,23.79 c0.267,0.07,0.54-0.09,0.61-0.357c0.018-0.068,0.021-0.139,0.01-0.208c-0.048-0.293-0.051-0.592-0.009-0.886 c0.035-0.246-0.115-0.48-0.353-0.55c-0.586-0.174-1.155-0.401-1.7-0.677v-1.3C7.496,19.071,7.824,18.366,8.393,17.891z M24,17.557 c-0.002-1.518-1.232-2.749-2.75-2.751c-0.138,0-0.25-0.112-0.25-0.25c-0.002-1.518-1.232-2.748-2.75-2.75h-1.5 c-1.518,0.002-2.748,1.232-2.75,2.75c0,0.138-0.112,0.25-0.25,0.25c-1.518,0.002-2.748,1.233-2.75,2.751v3.5 c0.002,1.518,1.232,2.748,2.75,2.749h7.5c1.518-0.001,2.748-1.231,2.75-2.749V17.557z M15.5,14.557 c0.001-0.69,0.56-1.249,1.25-1.25h1.5c0.69,0.001,1.249,0.56,1.25,1.25c0,0.138-0.112,0.25-0.25,0.25h-3.5 C15.612,14.807,15.5,14.695,15.5,14.557C15.5,14.557,15.5,14.556,15.5,14.557L15.5,14.557z",
    stroke: "none",
    fill: fill,
    strokeWidth: "0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
Travel2.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Travel2.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Travel2;